<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-profile" width="18" height="18" fill="none" viewBox="0 0 18 18">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4331 6.60203C11.4331 8.01425 10.2883 9.15905 8.8761 9.15905C7.46394 9.15905 6.31913 8.01425 6.31913 6.60203C6.31913 5.18981 7.46394 4.04501 8.8761 4.04501C10.2883 4.04501 11.4331 5.18981 11.4331 6.60203ZM8.8761 10.4931C11.0251 10.4931 12.7671 8.75102 12.7671 6.60203C12.7671 4.45304 11.0251 2.71094 8.8761 2.71094C6.72714 2.71094 4.98506 4.45304 4.98506 6.60203C4.98506 7.28684 5.16196 7.93034 5.47257 8.4893C3.36878 9.81956 1.9834 12.328 1.9834 15.1623C1.9834 15.5307 2.28204 15.8293 2.65043 15.8293H15.1018C15.4702 15.8293 15.7688 15.5307 15.7688 15.1623C15.7688 14.0287 15.5477 12.9497 15.149 11.9776C15.0092 11.6368 14.6195 11.4738 14.2787 11.6136C13.9379 11.7534 13.7749 12.1431 13.9147 12.4839C14.1694 13.1048 14.3388 13.7817 14.4043 14.4952H3.34784C3.54789 12.3122 4.71817 10.4841 6.3192 9.53513C7.003 10.1317 7.89735 10.4931 8.8761 10.4931Z"
      fill="currentColor"
    />
  </BaseSvg>
</template>
